import React from "react"

class ModalButtons extends React.Component {

  constructor(props) {
    super(props);

    this.renderButtonMarkup = this.renderButtonMarkup.bind(this);
  }

  componentDidMount() {
    this.setupButtons();
  }

  componentDidUpdate(prevProps) {
    if (!this.areEqual(prevProps.buttons, this.props.buttons) || this.props.triggerUpdate) {
      this.setupButtons();
    }
  }

  /*
  * Render functions
  */

  render() {
    return null;
  }

  renderButtonMarkup(button) {
    // type classes
    if (button.button_classes && button.button_classes.length) {
      var button_classes = button.button_classes.slice(0);
      button_classes.unshift('');
      button_classes = button_classes.join(' btn-');
    }

    // html_attributes
    if (button.html_attributes && button.html_attributes.length) {
      var button_html_attributes = button.html_attributes.slice(0);
      button_html_attributes.unshift('');
      button_html_attributes = button_html_attributes.join(' ');
    }
    // return button.a_tag ? `<a class="btn modal-iframe btn-primary" data-fullscreen=${button.fullscreen || "false"} href=${button.href} ${'disabled'}>${button.name}</a>` : '<button type="' + (button.type || 'button') + '" class="no-ladda btn '  + (button_classes || ' btn-secondary') + '" ' + (button_html_attributes && button_html_attributes.length ? button_html_attributes : '') + '>' + button.name + '</button>';

    return button.a_tag ? `<a class="btn modal-iframe btn-primary" data-fullscreen=${button.fullscreen || "false"} href=${button.href} ${button.disabled || this.props.loading ? 'disabled' : ''}>${button.name}</a>` : '<button type="' + (button.type || 'button') + '" class="no-ladda btn ' + (button_classes || ' btn-secondary')
      + '" ' + (button_html_attributes && button_html_attributes.length ? button_html_attributes : '') + `${this.props.loading ? 'disabled' : ''}>` + button.name + '</button>';
  }

  /*
  * Helper functions
  */

  setupButtons() {
    var self = this;
    var $footer = $('.modal-footer .modal-footer-button-container');
    if ($footer && $footer.length && this.props.buttons && this.props.buttons.length) {
      $footer.html('');

      // build buttons
      for (var i = 0, ilen = this.props.buttons.length; i < ilen; i++) {
        var $button = $(this.renderButtonMarkup(this.props.buttons[i]));

        // handle onClick (if required)
        if (typeof this.props.buttons[i].onClick == 'function') {
          (function (onClick) {
            var onClick = onClick.bind(this);
            $button.on('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              onClick(e);
            });
          })(this.props.buttons[i].onClick);
        }

        $footer.append($button);
      }
    }
  }

  areEqual(a, b) {
    if (a && b) {
      // Create arrays of property names
      var aProps = Object.getOwnPropertyNames(a);
      var bProps = Object.getOwnPropertyNames(b);

      // If number of properties is different,
      // objects are not equivalent
      if (aProps.length != bProps.length) {
        return false;
      }

      for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
          return false;
        }
      }

      // If we made it this far, objects
      // are considered equivalent
      return true;
    } else {
      return false;
    }
  }

}

export default ModalButtons